'use client';
import {
  createPortableDialog,
  usePortableDialog,
} from '@wwe-portal/ui/components/dialog';
import { Button } from '@wwe-portal/ui/components/button/button';
import { OutStockWebCoinDialog } from '@wwe-portal/ui/features/club-store/dialog';
import { CATEGORY_IDS } from '@wwe-portal/web/utils/constants/offer';
import { useRouter } from 'next/navigation';

export const NotEnoughWebCoinDialog = createPortableDialog(
  ({ onClose }: { onClose?: () => void }) => {
    const modal = usePortableDialog();
    const router = useRouter();

    const handleClose = () => {
      onClose?.();
      modal.remove();
    };
    return (
      <OutStockWebCoinDialog
        open={modal.visible}
        onClose={handleClose}
        data={{
          actionElement: (
            <div className="flex w-full justify-center">
              <Button
                className="w-full max-w-[120px] truncate text-xs font-semibold"
                variant="blue"
                onClick={() => {
                  router.push(
                    `/special-offers?category=${CATEGORY_IDS.WEBCOINS}`
                  );
                  handleClose();
                }}
              >
                Go to Shop
              </Button>
            </div>
          ),
        }}
      />
    );
  }
);
